import { logEvent } from "firebase/analytics";
import { analytics } from "./firebase"; // or wherever your analytics is initialized

export const logPostView = (companyName) => {
  console.log(`Logging post view for company: ${companyName}`);
  if (analytics) {
    logEvent(analytics, 'interview_read', {
      company: companyName,
    });
  }
};